module.exports = __webpack_public_path__ + "media/images/emblems/Berg_am_irchel-blazon-95276d127dc0b8cdf3d7a032cc6bc153.svg";